import {createAction, handleActions} from 'redux-actions';
import * as func from "../../utils/functions";

const SET_JOURNALS = 'journal/SET_JOURNALS';
export const setJournals = createAction(SET_JOURNALS);
const SET_JOURNAL = 'journal/SET_JOURNAL';
export const setJournal = createAction(SET_JOURNAL);

// 초기 state를 정해줍니다
let initialState = {
	param: {
		'current_page': 1,
		'record_per_page': 30,
		'ks': '',
		'sub_ks': '',
		'jcr_category': [],
		'scopus_category': [],
		'kci_category': [],
		'publisher': [],
		'registered_db_name': [],
		'registered_db_year': [],
		'journal_ranking': '',
		'dept': [],
		'order_by': rmVars.isAdmin ? 'date' : 'ranking',
		'order': rmVars.isAdmin ? 'desc' :'asc',
		'journal_status' : [],
		'date_type' : 'input_date',
		'in_date_start' : '',
		'in_date_end' : '',
		'worker_name' : '',
	},
	records: [],
	checkedRecords : [],
	facet: {},
	totalRecords: 0,
	totalPage: 0,
	record: {},
	meta: {},
	similar: null,
	fullText: [],
	isPopup1: 'false',
	type: '',
	showSide : func.getCookie('side') === 'true' ? 'true' : 'false'
}

export default handleActions({
	[SET_JOURNALS]: (state, action) => {
		// console.log(state);
		action.payload = action.payload ? action.payload : {}
		return {
			...state,
			param: {
				...state.param,
				current_page: action.payload.param && action.payload.param.current_page ? action.payload.param.current_page : state.param.current_page,
				record_per_page: action.payload.param && action.payload.param.record_per_page ? action.payload.param.record_per_page : state.param.record_per_page,
				ks: action.payload.param && action.payload.param.ks ? action.payload.param.ks : state.param.ks,
				sub_ks: action.payload.param && action.payload.param.sub_ks ? action.payload.param.sub_ks : state.param.sub_ks,
				jcr_category: action.payload.param && action.payload.param.jcr_category ? action.payload.param.jcr_category : state.param.jcr_category,
				scopus_category: action.payload.param && action.payload.param.scopus_category ? action.payload.param.scopus_category : state.param.scopus_category,
				kci_category: action.payload.param && action.payload.param.kci_category ? action.payload.param.kci_category : state.param.kci_category,
				publisher: action.payload.param && action.payload.param.publisher ? action.payload.param.publisher : state.param.publisher,
				registered_db_name: action.payload.param && action.payload.param.registered_db_name ? action.payload.param.registered_db_name : state.param.registered_db_name,
				registered_db_year: action.payload.param && action.payload.param.registered_db_year ? action.payload.param.registered_db_year : state.param.registered_db_year,
				journal_ranking: action.payload.param && action.payload.param.journal_ranking ? action.payload.param.journal_ranking : state.param.journal_ranking,
				dept: action.payload.param && action.payload.param.dept ? action.payload.param.dept : state.param.dept,
				order_by: action.payload.param && action.payload.param.order_by ? action.payload.param.order_by : state.param.order_by,
				order: action.payload.param && action.payload.param.order ? action.payload.param.order : state.param.order,
				journal_status: action.payload.param && action.payload.param.journal_status ? action.payload.param.journal_status : state.param.journal_status,
				date_type: action.payload.param && action.payload.param.date_type ? action.payload.param.date_type : state.param.date_type,
				in_date_start: action.payload.param && action.payload.param.in_date_start ? action.payload.param.in_date_start : state.param.in_date_start,
				in_date_end: action.payload.param && action.payload.param.in_date_end ? action.payload.param.in_date_end : state.param.in_date_end,
				worker_name: action.payload.param && action.payload.param.worker_name ? action.payload.param.worker_name : state.param.worker_name,
				// : action.payload.param && action.payload.param.journal_status ? action.payload.param.journal_status : state.param.journal_status,
			},
			records: action.payload.records ? action.payload.records : state.records,
			checkedRecords : action.payload.checkedRecords ? action.payload.checkedRecords : state.checkedRecords,
			facet: action.payload.facet ? action.payload.facet : state.facet,
			totalRecords: action.payload.pageInfo ? action.payload.pageInfo.totalResults : state.totalRecords,
			totalPage: action.payload.pageInfo ? action.payload.pageInfo.totalPage : state.totalPage,
			isPopup1: action.payload.isPopup1 === 'true' ? 'true' : 'false',
			type: action.payload.type ? action.payload.type : state.type
		}
	},
	[SET_JOURNAL]: (state, action) => {
		return {
			...state,
			record: action.payload.record ? action.payload.record : state.record,
			meta: action.payload.meta ? action.payload.meta : state.meta,
			similar: action.payload.similar ? action.payload.similar : state.similar,
			fullText: action.payload.fullText ? action.payload.fullText : state.fullText,
			showSide: action.payload.showSide ? action.payload.showSide : state.showSide,
		}
	},
}, initialState)
